import React from 'react';

export interface HoverComponentProps {
  readonly normalElement: React.ReactNode;
  readonly hoverElement: React.ReactNode;
  readonly altText: string;
}

export function HoverComponent(props: HoverComponentProps): JSX.Element {
  const [isHovered, setHover] = React.useState(false);
  const onMouseEnter = () => setHover(true);
  const onMouseLeave = () => setHover(false);

  return (
    <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} title={props.altText}>
      {isHovered ? props.hoverElement : props.normalElement}
    </div>
  );
}
